module.exports = __webpack_public_path__ + "img/mv--hakari_sprite2.8d4a4791.png";